const emptyObject = {}

export const ModelFactoryMock = {
  instantiateClass: () => emptyObject
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/factories/model-factory/model-factory.mock.ts